/// <amd-module name="TFS/Views/SuiteMePage/SuiteMePageView/Announcement" />
import * as React from "react";

import { Pill, PillSize } from "VSSUI/Pill";
import { PillGroup } from "VSSUI/PillGroup";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { Link } from "VSSUI/Link";

import * as SuiteMePageResources from "TFS/Views/SuiteMePage/Resources";

interface IGlobalAnnouncementComponentState {
    announcement?: IGlobalAnnouncement;
}

/**
 * Announcement Props specifying how it will be rendered by the service
 */
export interface IGlobalAnnouncement {
    /**
     * The text for the pill
     */
    pillText?: string;

    /**
     * The header for the announcement
     */
    header?: string;

    /**
     * The href for the announcement
     */
    href?: string;

    /**
     * The text of the message.
     */
    message?: string;

    /**
     * The id to use to check whether the announcement has been dismissed
     */
    settingId?: string;

    /**
     * The priority of the dialog determines if it will be shown over others.
     */
    priority?: number;
}

interface IMessageData {
    announcements: IGlobalAnnouncement[];
}

const telemetryArea = "ms.vss-tfs-web.announcements";

export class GlobalAnnouncementComponent extends VssComponent<{}, IGlobalAnnouncementComponentState> {
    public static componentType = "globalAnnouncement";

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        const contributionService = context.pageContext.getService<IVssContributionService>("IVssContributionService");

        const messageData = contributionService.getData<IMessageData>("ms.vss-tfs-web.announcements-data-provider");

        const announcement = messageData && messageData.announcements ? messageData.announcements[0] : undefined;
        this.state = { announcement };
    }

    public render(): JSX.Element | null {
        const { announcement } = this.state;

        if (!announcement) {
            return null;
        }

        return (
            <div className={"global-announcement flex-column flex-grow fontSizeM "}>
                <Link
                    href={announcement.href}
                    className="announcement-link"
                    target="_blank"
                    onClick={e => this.announcementClicked(announcement.href)}
                    rel="noopener noreferrer"
                >
                    <PillGroup>
                        <Pill className="header-label colored dark" excludeFocusZone={true} excludeTabStop={true} size={PillSize.compact}>
                            {announcement.pillText || SuiteMePageResources.WhatsNew}
                        </Pill>
                    </PillGroup>
                    <div className="header body-m">{announcement.header}</div>
                    <div className="body-s">{announcement.message}</div>
                </Link>
            </div>
        );
    }

    private announcementClicked = (href: string | undefined) => {
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent(telemetryArea, "AnnouncementClicked", {
            href: href
        });
    };
}

// Register the global corner dialog with the layout manager
VssComponent.register(GlobalAnnouncementComponent.componentType, GlobalAnnouncementComponent);
